<template>
    <div :data-component="$options.name">
        <div class="p-16 border border-wildsand rounded-10">
            <slot name="title" />
            <div
                class="mb-8 text-text-l transition-all duration-200 ease-in-out overflow-hidden"
                :class="{ 'line-clamp-6 screen-m:line-clamp-3': !state.isExpanded }"
                :style="{ height: state.contentHeight }"
            >
                <div ref="expanderBoxContent">
                    <slot name="content" />
                </div>
            </div>
            <cs-expander
                v-if="showButton"
                :expanded="state.isExpanded"
                @update:expanded="toggleFullText"
            />
        </div>
    </div>
</template>
<script lang="ts" src="./MsExpanderBox.ts" />
